// extracted by mini-css-extract-plugin
export var growableInput = "_3n-0";
export var tagContainer = "_3n-2";
export var textInput = "_3n-1";